/* eslint-disable react/no-multi-comp */

import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import classNames from 'classnames';
import {Field} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import FormGroupField from '../../admin/FormGroupField';
import FileField from '../../form/FileField';
import RichEditorField from '../../rte/RichEditorField';

const BodyHtmlTypeTab = ({current, onClick, value, ...rest}) => {
    const handleClick = React.useCallback(() => onClick(value), [onClick, value]);
    return (
        <li className="nav-item"><a className={classNames('nav-link', {active: current === value})} onClick={handleClick} {...rest} /></li>
    );
};

const BodyHtmlType = ({field, form}) => {
    const handleClick = React.useCallback((value) => {
        form.setFieldValue(field.name, value);
    }, [field.name, form]);
    return (
        <div>
            <ul className="nav nav-tabs">
                <BodyHtmlTypeTab current={field.value} value={constants.EMAIL_TEMPLATE_TYPE.DEFAULT} onClick={handleClick}>
                    <FormattedMessage {...messages.trackers.sendModal.form.emailBodyHtmlTypeDefault} />
                </BodyHtmlTypeTab>
                <BodyHtmlTypeTab current={field.value} value={constants.EMAIL_TEMPLATE_TYPE.FILE} onClick={handleClick}>
                    <FormattedMessage {...messages.trackers.sendModal.form.emailBodyHtmlTypeFile} />
                </BodyHtmlTypeTab>
            </ul>
        </div>
    );
};

const EmailAlreadyLoadedAlert = () => (
    <small className="font-weight-bold"><FormattedMessage {...messages.trackers.sendModal.form.emailBodyHtmlTypeFileExists} /></small>
);

const EmailBodyHtmlFields = ({template, values}) => {
    return (
        <>
            <Field component={BodyHtmlType} name="emailBodyHtmlType" />
            {values.emailBodyHtmlType === constants.EMAIL_TEMPLATE_TYPE.DEFAULT &&
                <FormGroupField showParameters={false} showQuestions={false} component={RichEditorField} id="smmb-email_body_html" name="emailBodyHtml"
                    label={messages.trackers.sendModal.form.emailBodyHtml}
                    hasEmailLink />}
            {values.emailBodyHtmlType === constants.EMAIL_TEMPLATE_TYPE.FILE && (<>
                {template.emailBodyHtmlFile && <EmailAlreadyLoadedAlert />}
                <FormGroupField component={FileField} id="smmb-email_body_html_file" name="emailBodyHtmlFile"
                    label={messages.trackers.sendModal.form.emailBodyHtmlFile} /></>)}
        </>
    );
};

export default EmailBodyHtmlFields;
